import { connect } from 'react-redux';
import { getCurrentPurchase } from '../../selectors/purchase-selector';
import CommitRightHandSide from '../../components/commit-form/commit-right-hand-side';

const mapStateToProps = (state) => {
  const purchase = getCurrentPurchase(state);
  return { purchase };
};

export default connect(mapStateToProps)(CommitRightHandSide);



// WEBPACK FOOTER //
// ./src/desktop/containers/commit-form/commit-right-hand-side.container.js